"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const entity_1 = require("../../type/entity");
function getAvailableOnFromType(command, availableOnDetails) {
    const availableOnType = availableOnDetails.type;
    switch (availableOnType) {
        case entity_1.AvailableOnType.IMMEDIATE:
        case entity_1.AvailableOnType.FIXED:
        case entity_1.AvailableOnType.RELATIVE: {
            const fixedAvailableOnDetails = availableOnDetails;
            return new Date(fixedAvailableOnDetails.availableOn).toISOString();
        }
        case entity_1.AvailableOnType.DYNAMIC: {
            const dynamicAvailableOnDetails = availableOnDetails;
            const { timeStamp } = command;
            return date_fns_1.addDays(timeStamp, dynamicAvailableOnDetails.availableInDays).toISOString();
        }
    }
}
exports.getAvailableOnFromType = getAvailableOnFromType;
//# sourceMappingURL=getAvailableOn.js.map